import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

type Tab = 'customers' | 'abandoned-carts';

@Component({
  selector: 'app-customers-carts',
  templateUrl: './customers-carts.component.html',
  styleUrls: ['./customers-carts.component.scss'],
})
export class CustomersCartsComponent implements OnInit, OnDestroy {
  activeTab: Tab = 'customers';
  private routerSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.activeTab = this.resolveTabFromUrl(this.router.url);
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.activeTab = this.resolveTabFromUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  selectTab(tab: Tab): void {
    if (this.activeTab === tab) return;
    this.router.navigateByUrl(`/dashboard/${tab}`);
  }

  private resolveTabFromUrl(url: string): Tab {
    return url.includes('/dashboard/abandoned-carts')
      ? 'abandoned-carts'
      : 'customers';
  }
}
